export default __webpack_public_path__ + "static/Graphik-Regular-Web-5038847ba51d3ef44a4b725d198f944c.woff";